<template>
    <div class="term-line">
        <p class="uppercase text-capitalize text-center header">AGREEMENT</p>
        <p class="bold header header">Agreement</p>
        <p>The:</p>
        <p>terms and conditions set out in this document; and</p>

        <p>any other referenced policies and attachments together,</p>

        <p>
            comprise the agreement between Peiso Pty Ltd (ACN 643 390 890)
            (“Peiso”, “we”, “us” or “our”) and you (“Customer”, “you”) in respect
            of your access to and use of the Application (“Agreement”).
        </p>

        <p class="bold header">Acceptance</p>
        <p>
            By using the Application, you agree that you have read and agree to be
            bound by the Agreement.
        </p>

        <p>
            If you do not unconditionally agree to all the terms and conditions of
            the Agreement, you have no right to use the Application.
        </p>

        <p>
            Use of the Application is expressly conditioned upon your assent to
            all the terms and conditions of the Agreement, to the exclusion of all
            other terms.
        </p>

        <p class="bold header">Authority</p>
        <p>You represent and warrant to us that:</p>
        <p>
            you are a natural person or the entity you represent have the
            authority to enter into the Agreement;
        </p>
        <p>
            all registration information you submit to us is accurate and
            truthful; and you will maintain the accuracy of such information.
        </p>

        <p>
            You also certify that you are legally permitted to use and access the
            Application and take full responsibility for the selection and use of
            and access to the Application.
        </p>

        <p class="bold header">Amendment</p>
        <p>
            We reserve the right, in our sole discretion, to modify the Agreement
            at any time by posting a notice on the Website, or by sending you a
            notice via email or postal mail.
        </p>

        <p>
            You shall be responsible for reviewing and becoming familiar with any
            such modifications.
        </p>

        <p>
            Your use of the Application following such notification constitutes
            your acceptance of the terms and conditions of the Agreement as
            modified.
        </p>

        <p class="uppercase text-capitalize header">THE APPLICATION</p>

        <p class="bold header">Access</p>
        <p>
            Subject to the terms set out in the Agreement, we will use all
            reasonable commercial efforts to provide you with access to and use of
            the Application.
        </p>

        <p>
            You agree to provide us with any information reasonably necessary for
            the provision of the Application, including but not limited to,
            providing information and technology as necessary and appropriate.
        </p>

        <p class="bold header">Your responsibility</p>
        <p>
            You are responsible for your use of, or reliance on, any advice or
            recommendations provided by us in connection with the Application,
            including but not limited to, the security and access settings that
            may be configured for the Application.
        </p>

        <p class="uppercase text-capitalize header">TERM</p>

        <p class="bold header">Subscription Period</p>
        <p>
            Your use of the Application is provided on a Subscription Plan basis
            and a term is associated with that Subscription Plan (Subscription
            Period).
        </p>

        <p class="bold header">Renewal</p>
        <p>
            Unless either party gives written notice of non-renewal to the other
            party thirty days prior to the end of the Subscription Period, your
            Subscription Plan will be automatically renewed for a period equal to
            the initial Subscription Period (and you will be charged at the
            then-current Fees).
        </p>

        <p class="uppercase text-capitalize header">FEES AND PAYMENT TERMS</p>

        <p class="bold header">Fees</p>
        <p>You shall pay all Fees applicable to your use of the Application.</p>

        <p>All Fe es are payable in advance.</p>

        <p>
            Before using the Application, you must provide a valid credit (or
            debit) card to our online payments and billing provider - Stripe.
        </p>

        <p>
            Your credit (or debit) card must remain valid and hold appropriate
            cleared funds to cover any Fees as and when they become payable.
        </p>

        <p>
            Upon submitting your credit (or debit) card information to Stripe, you
            acknowledge and agree to the Stripe privacy policy, services
            agreement, payment terms and financial services terms, along with any
            other appropriate Stripe terms and conditions. The applicable terms
            for your jurisdiction can be found at the Stripe website located at
            www.stripe.com.
        </p>

        <p>
            We accept no responsibility and/or Liability of any kind in relation
            to your credit (or debit) card information and/or any issues, changes
            to, or irregularities associated with the Stripe payment platform.
        </p>
        <p>
            You authorise us (and Stripe) to deduct the amount of the Fees from
            your credit (or debit) card on the due date for payment.
        </p>

        <p>
            Except as expressly stated in the Agreement or required by applicable
            law, the Fees are non-refundable and non-creditable.
        </p>

        <p class="bold header">Changes to Price List</p>
        <p>
            We reserve the right to modify the Price List and to institute new
            Fees at any time, upon notice to you, which may be sent by email or
            posted on the Website. Your use of the Application following such
            notification constitutes your acceptance of the modified Price List
            and any new or increased Fees.
        </p>

        <p class="bold header">Billing Data</p>
        <p>
            You must provide current, complete and accurate billing information
            (“Billing Data”) for your Subscription Plan.
        </p>

        <p>
            You must promptly update all Billing Data to keep your Subscription
            Plan current, complete and accurate (such as a change in billing
            address, credit card number, credit card expiration date or bank
            account details) and you must promptly notify us if your payment
            method is changed (for example, for loss or theft) or if you become
            aware of a potential breach of security, such as the unauthorised
            disclosure or use of your name or password.
        </p>

        <p class="bold header">Taxes</p>
        <p>
            The Fees and other amounts required to be paid under the Agreement do
            not include any amount for taxes or levy (including interest and
            penalties).
        </p>

        <p>
            You agree to reimburse us for all sales, use, VAT, excise, property or
            other taxes or levies which we are required to collect or remit to
            applicable tax authorities.
        </p>

        <p class="bold header">Late payment</p>
        <p>
            If you fail to pay any Fees by the due date, we may, in our
            discretion, suspend your access to the Application until such overdue
            fees are paid.
        </p>

        <p>
            Any late payment of Fees will bear interest at the rate of 1.5% per
            month (prorated for partial periods) or at the maximum rate permitted
            by law, whichever is less.
        </p>

        <p>
            You agree that in the event we are unable to collect the Fees owed to
            us, we may take any other steps it deems necessary to collect such
            Fees from you and you will be responsible for all costs and expenses
            incurred by us in connection with such collection activity, including
            collection fees, court costs and attorneys’ fees.
        </p>

        <p class="uppercase text-capitalize header">GST</p>
        <p class="bold header">Amounts exclusive of GST</p>
        <p>
            Despite the definition of consideration in the GST law, and unless
            otherwise expressly stated in the Agreement, prices or other sums
            payable or consideration to be provided under or in accordance with
            the Agreement are exclusive of GST.
        </p>

        <p class="bold header">Liability for GST</p>
        <p>
            If a party makes a taxable supply under or in connection with the
            Agreement, the other party must pay to the supplier at the same time,
            and in addition to the GST-exclusive consideration, an amount equal to
            the GST payable on that supply.
        </p>

        <p>
            The supplier must, as a precondition to the payment of GST under
            clause 5.2(a), give the other party a tax invoice.
        </p>

        <p class="bold header">Adjustment</p>
        <p>
            If an adjustment event arises in connection with a supply made under
            the Agreement, the supplier must give the other party an adjustment
            note in accordance with the GST law.
        </p>

        <p class="bold header">Reimbursement</p>

        <p>
            If the Agreement requires one party to pay for, reimburse or
            contribute to any expense, loss or outgoing suffered or incurred by
            the other party, the amount required to be paid, reimbursed or
            contributed by the first party will be reduced by the amount of input
            tax credits (if any) to which the other party is entitled in respect
            of the reimbursable expense.
        </p>

        <p class="uppercase text-capitalize header">CONFIDENTIALITY</p>
        <p class="bold header">Confidentiality</p>
        <p>
            A party will not, without the prior written approval of the other
            party, disclose the other party’s Confidential Information.
        </p>

        <p>
            Each party will take all reasonable steps to ensure that its employees
            and agents, and any sub-contractors engaged for the purposes of the
            Agreement, do not make public or disclose the other party’s
            Confidential Information.
        </p>

        <p class="bold header">Exceptions</p>
        <p>
            A party will not be in breach of this clause 6 in circumstances where
            it is legally compelled to disclose the other party’s Confidential
            Information.
        </p>

        <p>
            Notwithstanding any other provision of this clause 6, a party may
            disclose the terms of the Agreement (other than Confidential
            Information of a technical nature) to its related companies,
            solicitors, auditors, insurers and accountants.
        </p>

        <p class="bold header">Injunctive relief</p>
        <p>
            Each party acknowledges that any unauthorised disclosure or use of the
            Confidential Information would cause the other party imminent
            irreparable injury and that such party will be entitled to, in
            addition to any other remedies available at law or in equity,
            temporary, preliminary, and permanent injunctive relief in the event
            the other party does not fulfill its obligations under this clause.
        </p>

        <p class="bold header">Suggestions regarding the Application</p>
        <p>
            Notwithstanding this clause, unless otherwise expressly agreed in
            writing, all suggestions, solutions, improvements, corrections, and
            other contributions provided by you regarding the Application or other
            materials provided to you will be owned by us, and you hereby agree to
            assign any such rights to us.
        </p>

        <p class="uppercase text-capitalize header">PRIVACY</p>

        <p class="bold header">Privacy Policy</p>
        <p>
            You agree and consent to our handling of Personal Information in
            accordance with our Privacy Policy.
        </p>

        <p>
            We may change our Privacy Policy at any time by giving notice to you.
        </p>

        <p class="bold header">Users</p>
        <p>You must inform each User:</p>
        <p class="circle">of our Privacy Policy; and</p>
        <p class="circle">
            that the User’s Personal Information will be disclosed to us.
        </p>

        <p class="circle">
            We reserve the right to immediately terminate the Agreement if you are
            in breach of clause 7.2(a).
        </p>

        <p class="bold header">INTELLECTUAL PROPERTY RIGHTS</p>

        <p class="bold header">Reservation of rights</p>
        <p>
            All right, title and interest in and to the Software (and any
            modifications, customisations, configurations and derivative works of
            the Software) worldwide are our exclusive property.
        </p>

        <p>
            All such rights in and to the Software not expressly granted to you
            under clause 8.2 are reserved by us and our licensors.
        </p>

        <p class="bold header">Limited Licence</p>
        <p>
            We grant you a limited, non-exclusive, non-transferable, revocable
            licence to access and use the Application to the extent permitted by
            the Agreement, solely for your internal business purposes, to perform
            the functions described in the Documentation.
        </p>

        <p>
            The licence under clause 8.2(a) will remain in effect until the
            Agreement expires or is terminated by you or by us, except where we
            suspend your access to the Application as described in the Agreement.
        </p>

        <p>
            The licence under clause 8.2(a) does not grant you any ownership
            rights nor any other right or licence of any kind except as expressly
            set out above including, without limitation, any right to obtain
            possession of any source code, data or other technical materials in
            relation to the Application), in respect of any of the Application or
            the Intellectual Property Rights or proprietary information belonging
            to us or our licensors, including without limitation where they form
            part of the Application.
        </p>

        <p class="bold header">Users</p>
        <p>
            In selecting your Subscription Plan, you must nominate the person(s)
            who will have access to the Application (Users).
        </p>

        <p>
            We will assign a login to each of your nominated Users (User Login).
        </p>
        <p>
            Users must be:a current employee; orsubject to clause 5, third party
            contractors who do not compete with us.
        </p>

        <p>
            You agree to notify us immediately if a User ceases to satisfy the
            requirements of clause 8.3(c).
        </p>

        <p>
            You must ensure that only one individual makes use of a User Login.
        </p>

        <p>
            You are responsible and liable for the acts and omissions of your
            nominated User(s).
        </p>

        <p class="bold header">Limitations</p>
        <p>You agree that you will not, and your Users will not:</p>
        <p class="circle">
            permit any third party to access or use the Application;
        </p>
        <p class="circle">
            modify, adapt, alter, copy, make derivative works, translate, reverse
            engineer, decompile, disassemble or otherwise derive or determine the
            Application (or the underlying ideas, algorithms, structure or
            organisation) or attempt to do any of these things;
        </p>
        <p class="circle">
            disclose or transmit any content or data contained in the Application
            (not including Your Content) to any third party;
        </p>
        <p class="circle">
            circumvent or endanger the operation or security of the Application or
            attempt to do any of these things and you will use your reasonable
            endeavours to ensure that any Users also comply with these
            limitations.
        </p>
        <p>
            You grant us a non-exclusive, worldwide, irrevocable (for the term of
            the Agreement) licence to handle and process Your Content for the
            purposes of providing you with the Application and for all other
            purposes described in the Agreement and our Privacy Policy and Cookie
            Policy.
        </p>

        <p>
            You agree that we are permitted to run data analytics on Your Content
            for the purposes of supporting the provision and development of the
            Application and machine learning.
        </p>

        <p class="bold header">Remedies</p>
        <p>
            Should the Application become, or in our opinion is likely to become,
            the subject of a claim of infringement, we may, at our option:
        </p>
        <p class="circle">
            obtain the right for you to continue using the Application;
        </p>
        <p class="circle">
            replace or modify the Application so it is no longer infringing or
            reduces the likelihood that it will be determined to be infringing, or
        </p>
        <p class="circle">
            if neither of the foregoing options is commercially reasonable,
            terminate the access and use of the Application.
        </p>

        <p>
            Upon termination under 8.5(a)(iii), you shall cease accessing the
            Application and Service Provider will refund to you, as your sole
            remedy for such licence termination, the Fees paid by you for the
            terminated licence in the past six (6) months.
        </p>

        <p class="bold header">Third Party Terms</p>
        <p>
            The Application may contain third party software that requires notices
            and/or additional terms and conditions (Third-Party Terms).
        </p>

        <p>
            By accepting the Agreement, Customer is also taken to accept
            Third-Party Terms (if any).
        </p>

        <p class="uppercase text-capitalize header">TERMINATION</p>

        <p class="bold header">Termination by us</p>
        <p>The Agreement may be terminated by us:</p>
        <p class="circle">
            if your access to the Application has been suspended for more than
            twenty (20) days;
        </p>
        <p class="circle">
            on ten (10) days written notice to you if you fail to perform any
            other material obligation required of you under the Agreement, and
            such failure is not cured within such ten (10) day period; or
        </p>
        <p class="circle">you are subject to an Insolvency Event.</p>

        <p class="bold header">Termination by you</p>
        <p>
            The Agreement may be terminated by you on written notice to us. Such
            termination will take effect at the end of the current Subscription
            Period.
        </p>

        <p class="bold header">Effect of termination</p>
        <p>Upon termination of the Agreement:</p>
        <p class="circle">
            you will no longer access the Application and you will not circumvent
            any security mechanisms contained therein; and
        </p>
        <p class="circle">
            we will have no obligation to maintain or provide any of Your Content,
            and may, unless legally prohibited, delete all Your Content in our
            possession or control.
        </p>
        <p>
            On termination or expiry of the Agreement, all unpaid Fees become
            immediately due and payable.
        </p>

        <p class="bold header">Other remedies</p>
        <p>
            Termination of the Agreement will not limit either party from pursuing
            other remedies available to it, including injunctive relief, nor will
            such termination relieve your obligation to pay all Fees that have
            accrued or are otherwise owed by you under the Agreement.
        </p>

        <p class="uppercase text-capitalize header">LIABILITY</p>

        <p class="bold header">Disclaimer of warranty</p>
        <p>
            All express or implied guarantees, warranties, representations, or
            other terms and conditions relating to the Agreement or its subject
            matter, not contained in the Agreement, are excluded from the
            Agreement.
        </p>

        <p>
            If any guarantee, warranty, term or condition is implied or imposed in
            relation to the Agreement under any applicable legislation and cannot
            be excluded (“Non-Excludable Provision”), and we are able to limit
            your remedy for a breach of the Non-Excludable Provision, then our
            Liability for breach of the Non-Excludable Provision is limited (at
            our option) to:
        </p>
        <p class="circle">
            in the case of goods, the replacement of the goods or the supply of
            equivalent goods, the repair of the goods, the payment of the cost of
            replacing the goods or of acquiring equivalent goods, or the payment
            of the cost of having the goods repaired; or
        </p>
        <p class="circle">
            in the case of services, the supplying of the services again, or the
            payment of the cost of having the services supplied again.
        </p>

        <p>Limitation of liability</p>
        <p>
            Subject to clause 10.2(b), to the maximum extent permitted by law, our
            maximum aggregate Liability to you under or in connection with the
            Agreement or its subject matter, is limited to the amount of the Fees
            you paid to us in the 6 months prior to the Liability arising.
        </p>

        <p>
            To the extent permitted by law, we exclude all Liability to you under
            or in connection with the Agreement or its subject matter arising from
            your access to or use of a Beta Version Application.
        </p>

        <p>
            To the extent permitted by law, we exclude all Liability to you (and
            anyone claiming through you) for any Consequential Loss, even if it
            was reasonably foreseeable, arose naturally, or was contemplated by
            the parties in relation to the events giving rise to that Liability.
        </p>

        <p>
            Our Liability to you under or in connection with the Agreement or its
            subject matter is reduced to the extent that your acts or omissions,
            or those of a third party, contribute to or cause such Liability.
        </p>

        <p>
            The limitations and exclusions in this clause 10.2 apply regardless of
            the basis on which our Liability arises, whether in contract, tort
            (including but not limited to negligence), in equity, under statute or
            on any other basis.
        </p>

        <p class="bold header">Recommendations</p>
        <p>
            The Application may generate recommendations, comments and prompts,
            including but not limited to predictive insights or statistical
            analysis (“Recommendations”).
        </p>

        <p>Recommendations are based on:</p>
        <p class="circle">data you enter into the Application; and</p>
        <p class="circle">
            data we obtain through integration with your business (eg.
            point-of-sale systems, rostering system, accounting platform),
        </p>
        <p class="circle">together, “Source Data”.</p>
        <p>You acknowledge and agree that:</p>
        <p class="circle">
            we have no control over the Source Data, and its impact on the
            Recommendations; and
        </p>
        <p class="circle">
            we exclude all Liability in relation to the accuracy or precision of
            any Recommendation.
        </p>

        <p>You maintain full responsibility for determining:</p>
        <p class="circle">whether to adopt any Recommendation; and</p>
        <p class="circle">
            whether the Application or the information generated by it (including
            any Recommendation) is accurate or sufficient for your purposes.
        </p>
        <p>
            You release and indemnify us in respect of any decline in the
            performance of your business arising from the adoption of any
            Recommendation.
        </p>

        <p>Other exclusions</p>
        <p>
            We have no Liability to you for any improper access, copying or
            corruption of information before it enters or once it leaves our
            systems.
        </p>

        <p>
            We are not responsible for delays, disruptions or other faults in the
            Application caused by factors beyond our reasonable control, including
            but not limited to problems with the public internet or your computer
            systems, the acts and omissions of third parties, acts of God such as
            fires, storms, floods, earthquakes, or changes to laws or government
            actions.
        </p>

        <p>
            We are not responsible for any damage to any of your equipment or
            software resulting from your use of the Application.
        </p>

        <p>
            ANY AND ALL OF SOFTWARE AND ANY OTHER TECHNOLOGY OR MATERIALS PROVIDED
            BY US TO YOU (INCLUDING A BETA VERSION APPLICATION) ARE PROVIDED “AS
            IS” AND WITHOUT WARRANTY OF ANY KIND. WE MAKE NO OTHER WARRANTIES,
            EXPRESS OR IMPLIED, INCLUDING EXPRESS OR IMPLIED WARRANTIES OF
            MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, AND
            NONINFRINGEMENT. WE DO NOT WARRANT OR REPRESENT THAT THE APPLICATION
            (INCLUDING A BETA VERSION APPLICATION) WILL BE UNINTERRUPTED,
            ERROR-FREE, OR SECURE. YOU ACKNOWLEDGE THAT THERE ARE RISKS INHERENT
            IN INTERNET CONNECTIVITY THAT COULD RESULT IN THE LOSS OF YOUR
            CONTENT. YOU AGREE THAT NO ADVICE OR INFORMATION, WHETHER ORAL OR
            WRITTEN, OBTAINED BY YOU FROM US OR THROUGH OR FROM THE APPLICATION
            (INCLUDING A BETA VERSION APPLICATION) WILL CREATE ANY WARRANTY NOT
            EXPRESSLY STATED IN THE AGREEMENT AND THAT NO ACCOUNTING, FINANCIAL OR
            LEGAL ADVICE OR COUNSEL IS GIVEN OR SHALL BE DEEMED TO HAVE BEEN GIVEN
            BY THE APPLICATION (INCLUDING A BETA VERSION APPLICATION).
        </p>

        <p class="uppercase text-capitalize header">INDEMNIFICATION</p>

        <p class="bold header">Your indemnity to us</p>
        <p>
            You agree to defend, indemnify, and hold us and our officers,
            directors, employees, consultants, and agents harmless from and
            against any and all Liability incurred in connection with any Claim
            arising from or relating to:
        </p>

        <p class="circle">
            your breach of any of any obligations under the Agreement;
        </p>
        <p class="circle">your gross negligence or wilful misconduct;</p>
        <p class="circle">
            any loss or damage sustained or incurred by you (including
            Consequential Loss) arising from your access to or use of a Beta
            Version Application, even if it was reasonably foreseeable, arose
            naturally, or was contemplated by the parties in relation to the
            events giving rise to that Liability;
        </p>
        <p class="circle">
            your actual or alleged use of the Application in violation of the
            Agreement or applicable law by you or any of your Users; or
        </p>
        <p class="circle">
            Your Content, including but not limited to any Claim that Your Content
            or our handling or processing of Your Content infringes the
            Intellectual Property Rights of a third party.
        </p>

        <p class="bold header">Indemnification procedures</p>
        <p>In respect of the indemnities set out in clause 11.1:</p>
        <p>the indemnified party must:</p>
        <p class="circle">
            promptly notify the indemnifying party of any such Claim,
        </p>
        <p class="circle">
            provide full authority to the indemnifying party to assume control of
            the defence and settlement of any such Claim, provided that the
            indemnified party will retain the right to defend or settle any
            portion of a Claim to the extent that it is not within scope of the
            relevant indemnity;
        </p>
        <p class="circle">
            cooperate with the indemnifying party (at the indemnifying party’s
            expense) in relation to the Claim; and
        </p>
        <p class="circle">
            not make admissions in relation to the Claim without the prior consent
            of the indemnifying party (such consent not to be unreasonably
            withheld); and
        </p>
        <p>
            if the indemnifying party does not assume control of the defence and
            settlement of any such Claim within a reasonable period of time, the
            indemnified party will have the right to defend the Claim in such
            manner as it may consider appropriate.
        </p>

        <p class="uppercase text-capitalize header">DISPUTE RESOLUTION</p>

        <p class="bold header">Dispute Resolution Process</p>
        <p>
            If a dispute arises under the Agreement, either party may at any time
            give written notice to the other, requesting that a meeting take place
            to seek to resolve the dispute.
        </p>

        <p>
            Nominated representatives of the parties must meet within seven days
            of the notice and endeavour to resolve the dispute in good faith.
        </p>

        <p>
            If the meeting referred to in clause 12.1(b) does not take place
            within the required timeframe, or the dispute is not resolved within 7
            days after the parties first meet, then either party may refer the
            matter for mediation and a mediator appointed in accordance with
            clause 12.2 and 12.3.
        </p>

        <p class="bold header">Mediation</p>
        <p>
            The parties must take the steps set out in this clause 12, before
            either may commence court proceedings other than an interlocutory
            application.
        </p>

        <p class="bold header">Rules</p>
        <p>
            If a party refers a dispute to mediation the mediation will be
            administered by the Australian Commercial Disputes Centre (“ACDC”) and
            will be conducted in accordance with the ACDC Mediation Guidelines
            which set out the procedures to be adopted, the process of selection
            of the mediator and the costs involved and the terms of those
            Guidelines are incorporated into this document.
        </p>

        <p>
            If the mediation has not commenced within thirty (30) days after a
            party referred the dispute to mediation, or the dispute remains
            unresolved thirty (30) days after the appointment of the mediator,
            either party may pursue its rights at law.
        </p>

        <p class="bold header">Continuing performance</p>
        <p>
            During a dispute, each party must continue to perform its obligations
            under the Agreement.
        </p>

        <p>
            This clause 12 does not restrict or limit the right of either party to
            terminate the Agreement where the Agreement provides such right.
        </p>

        <p class="bold header">Costs</p>

        <p>
            Each party must bear its own costs in connection with the mediation
            and must share the fees and expenses of the mediator and mediation
            process equally, including any fees and expenses associated with the
            appointment of the mediator.
        </p>

        <p class="uppercase text-capitalize header">NOTICES</p>

        <p class="bold header">Requirement for writing and signature</p>
        <p>
            A notice, consent, approval request or demand made or required by the
            Agreement must be
        </p>
        <p>in writing; and</p>
        <p>signed by:</p>
        <p class="circle">
            the party giving the notice or that party's solicitor; or
        </p>
        <p class="circle">
            any other person nominated by the party giving the notice as being
            able to sign notices.
        </p>

        <p class="bold header">Serving notices</p>
        <p>A party may only serve a notice on the other party by:</p>
        <p class="circle">delivering it to the other party by hand; or</p>
        <p class="circle">
            sending it by registered or pre-paid post to the address nominated by
            the other party; or
        </p>
        <p class="circle">
            sending it by email to the email address nominated by the other party.
        </p>

        <p class="bold header">When effective</p>
        <p>A notice or communication will take effect:</p>
        <p class="circle">
            if given personally - on the day the communication is given provided
            the notice or communication is given by 4.00pm on that day or, if
            given after 4.00pm, the notice or communication will take effect from
            the next Business Day; or
        </p>
        <p class="circle">
            if posted – three (3) days after the notice or communication is sent.
        </p>
        <p class="circle">If emailed – at the time of transmission.</p>

        <p class="uppercase text-capitalize header">MISCELLANEOUS</p>

        <p class="bold header">Governing law and jurisdiction</p>
        <p>
            The Agreement will be governed by the laws of New South Wales,
            Australia.
        </p>

        <p>
            Each party submits to the non-exclusive jurisdiction of the courts of
            New South Wales and the Commonwealth of Australia.
        </p>

        <p class="bold header">Entire agreement</p>
        <p>
            The Agreement constitutes the entire agreement between you and us in
            connection with the Application and will supersede all previous
            communications (either oral or written) between you and us with
            respect to the subject matter of the Agreement.
        </p>

        <p class="bold header">No waiver</p>
        <p>
            A right may only be waived in writing, signed by the party giving the
            waiver, and:
        </p>
        <p class="circle">
            no other conduct of a party (including a failure to exercise, or delay
            in exercising, the right) operates as a waiver of the right or
            otherwise prevents the exercise of the right;
        </p>
        <p class="circle">
            a waiver of a right on one or more occasions does not operate as a
            waiver of that right if it arises again; and
        </p>
        <p class="circle">
            the exercise of a right does not prevent any further exercise of that
            right or of any other right.
        </p>

        <p class="bold header">Severability</p>
        <p>
            Any part of the Agreement that is wholly or partially void or
            unenforceable is severed to the extent that it is void or
            unenforceable. The validity or enforceability of the remainder of the
            Agreement is not affected.
        </p>

        <p class="bold header">Assignment</p>
        <p>
            You may not assign the Agreement or any part of it, or transfer any of
            your rights under it, to a third party without our prior written
            consent.
        </p>

        <p>
            We may not assign the Agreement or any part of it, or transfer any of
            our rights under it, without your prior written consent, except where
            such assignment or transfer is in connection with an internal
            restructure of our business or where we sell or divest some or all of
            our business in which case we may do so by notifying you accordingly.
        </p>

        <p class="bold header">Survival</p>
        <p>
            The provisions of the Agreement that by their nature survive
            termination or expiry of the Agreement will do so.
        </p>

        <p class="uppercase text-capitalize header">DEFINITIONS AND INTERPRETATION</p>

        <p class="bold header">Definitions</p>
        <p>For the purposes of the Agreement:</p>

        <p>Agreement has the meaning given in clause 1.1.</p>

        <p>
            Application means our proprietary software called ”Peiso” or “Peiso
            Profitability Software” as further described in the Documentation, and
            unless otherwise specified includes a Beta Version Application.
        </p>

        <p>Arbitration Rules has the meaning given in clause 12.1.</p>

        <p>
            Beta Version Application means a version of the Application which we
            have notified to you is:
        </p>
        <p class="circle">a beta version of the Application; or</p>
        <p class="circle">
            a version of the Application that is subject to further testing by us.
        </p>
        <p>Claim means any claim, action, proceeding or demand.</p>

        <p>
            Confidential Information means information that is by its nature
            confidential, including but not limited to information relating to
            the:
        </p>
        <p class="circle">
            personnel, policies, practices, clientele or business strategies of
            the parties;
        </p>
        <p class="circle">Intellectual Property Rights of either party; or</p>
        <p class="circle">the terms of the Agreement,</p>
        <p class="circle">but does not include any Excluded Information.</p>

        <p>
            Consequential Loss means loss of revenue, loss of profits, loss of
            anticipated savings or business, pure economic loss, loss of data,
            loss of value of equipment (other than the cost of repair), loss of
            opportunity or expectation loss, and any other form of consequential,
            special, indirect, punitive or exemplary loss or damages.
        </p>

        <p>
            Documentation means user documentation that we make generally
            available in hard copy or electronic form to our general customer base
            in conjunction with the licensing of the Application.
        </p>

        <p>Excluded Information means information:</p>
        <p class="circle">
            is already known to the other party at the time of disclosure;
        </p>
        <p class="circle">
            is or becomes publicly known through no wrongful act or failure of the
            Recipient;
        </p>
        <p class="circle">
            is independently developed without benefit of the other party’s
            Confidential Information; or
        </p>
        <p class="circle">
            is received from a third party that is not under an obligation of
            confidentiality.
        </p>

        <p>Fees means the fees payable for use of the Application.</p>

        <p>
            Intellectual Property Rights means any and all intellectual and
            industrial property rights throughout the world, whether conferred by
            statute, common law or in equity and including but not limited to:
        </p>
        <p class="circle">
            rights in respect of or in connection with any confidential
            information including any right to enforce an obligation to keep
            information confidential;
        </p>
        <p class="circle">trade secrets;</p>
        <p class="circle">
            know-how including know-how or insights derived over time from
            provision of the Application but not including any personal
            information of customers;
        </p>
        <p class="circle">
            copyright including but not limited to future copyright and rights in
            the nature of or analogous to copyright;
        </p>
        <p class="circle">Moral Rights;</p>
        <p class="circle">
            inventions (including but not limited to patents, innovation patents
            and utility models);
        </p>
        <p class="circle">trade marks and service marks;</p>
        <p class="circle">designs, circuit layouts and mask works;</p>
        <p class="circle">domain names and social media accounts;</p>
        <p class="circle">technical data;</p>
        <p class="circle">rights in databases;</p>
        <p class="circle">trade names or business names;</p>
        <p class="circle">any rights in any Resulting Data; and</p>
        <p class="circle">
            any other rights resulting from intellectual activity or from
            artificial intelligence insights or machine learning, in relevant
            business sectors which subsist or which may come to subsist, whether
            or not now existing and whether or not registered or registrable and
            including but not limited to:
        </p>
        <p class="circle">
            any rights to apply for the registration of such rights and all
            renewals, extensions and reissues of such rights, anywhere in the
            world, and
        </p>
        <p class="circle">
            any rights of action against any third party in respect of any such
            rights including any right to claim or retain damages or other
            remedies.
        </p>

        <p>
            Liability means all claims, demands, actions, proceedings, losses
            (including Consequential Losses), damages, (including loss and damage
            to property), fines, penalties, costs, expenses (including legal fees
            on an indemnity basis) and other liabilities, whether arising in
            contract, tort (including negligence), equity, under statute or on any
            other legal basis.
        </p>

        <p>
            Moral Rights means moral rights as described in Article 6bis of the
            Berne Convention for the Protection of Literary and Artistic Works and
            any analogous rights arising under statute that exist, or may come to
            exist, anywhere in the world:
        </p>

        <p>Non-Excludable Provision has the meaning given in clause 10.1.</p>
        <p>
            Personal Information has the meaning given to that term in the Privacy
            Act 1988 (Cth).
        </p>

        <p>
            Price List means the webpage which sets out our Fees, available at
            www.peiso.com.au.
        </p>

        <p>
            Privacy Policy means our privacy policy, available at
            www.peiso.com.au.
        </p>

        <p>Recommendations has the meaning given in clause 10.3(a).</p>

        <p>
            Resulting Data means any data or information arising from use by any
            person of the Application, in anonymised or aggregated form and not
            including any of Your Content or personal information.
        </p>

        <p>Software means the Application and Documentation;</p>

        <p>Source Data has the meaning given in clause 10.3(b).</p>

        <p>
            Subscription Plan means one of the available subscription plans
            offered by us, as further described at www.peiso.com.au.
        </p>

        <p>
            Your Content means any data and materials inputted by you or any End
            User into the Application or stored within the Application or
            generated by the Application as a result of your use of the
            Application.
        </p>

        <p>User has the meaning given in clause 8.3(a).</p>

        <p>User Login has the meaning given in clause 8.3(b).</p>

        <p>Website means the website located at www.peiso.com.au.</p>
    </div>
</template>

<script>

export default {
    name: 'Terms'
}
</script>

<style lang="scss">
@import 'static/scss/scrollbar';
    .term-line {
        color: var(--text-color);
        &::-webkit-scrollbar {
            @extend .scrollbar;
        }

        &::-webkit-scrollbar-track {
            @extend .scrollbar-track;
        }

        &::-webkit-scrollbar-thumb {
            @extend .scrollbar-thumb;
        }
        p {
            font-size: 16px;
            white-space: normal;
            margin-bottom: 10px;
            letter-spacing: 0.01em;

            &.header {
                font-weight: 700;
                font-size: 18px;
                margin: 1rem 0;
                letter-spacing: 0.03em;
            }

            &.uppercase {
                margin-top: 2.5rem;
            }

        }
        
    }
</style>


// WEBPACK FOOTER //
// src/components/dashboard/component/terms.vue